import TitleDescription from '@/common/components/base/typography/TitleDescription';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { ParticipantCardWrapperType } from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardWrapper/ParticipantCardWrapper.type';
import Button from '@/common/components/base/button/Button';
import AddIcon from '@/common/assets/icons/add.svg?react';
import { token } from 'styled-system/tokens';
import { useParams } from 'react-router-dom';
import { fileEntryQueryOptions } from '@/modules/FileDetail/queries/fileEntry/fileEntryQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { FileStateType } from '@/common/types/Files.type';

const ParticipantCardWrapper = ({
  children,
  length = 1,
  addDamagedPerson,
}: ParticipantCardWrapperType) => {
  const { id } = useParams();
  const { data: fileData } = useQuery(fileEntryQueryOptions(id!));
  const hasMultiDamage =
    fileData?.status?.const === FileStateType.IN_PROGRESS && addDamagedPerson;
  return (
    <Box
      className={css({
        mt: '0.5rem',
        display: 'flex',
        flexDirection: 'column',
        borderBottomColor: hasMultiDamage ? 'gray-2' : '',
        borderBottomWidth: hasMultiDamage ? '1px' : '',
        borderBottomStyle: hasMultiDamage ? 'solid' : '',
        gap: '17px',
      })}
    >
      {hasMultiDamage ? (
        <Box
          className={css({
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',
          })}
        >
          <TitleDescription
            className={css({
              mb: '22px',
              textWrap: 'nowrap',
            })}
          >
            {`${length} زیان‌دیده`}
          </TitleDescription>

          <Button
            css={{
              position: 'relative',
              top: '-14px',
            }}
            gap="5px"
            variant="text"
            color="primary"
            position={'relative'}
            top="-10px"
            onClick={addDamagedPerson}
          >
            افزودن زیان‌دیده
            <AddIcon fill={token('colors.purple-1')} width={16} height={16} />
          </Button>
        </Box>
      ) : null}
      {children}
    </Box>
  );
};
export default ParticipantCardWrapper;
